import { mixinRobotoFont } from '@genesislcap/foundation-zero';
import { agThemeTokenMapCSS, AgGridCSSVars } from '@genesislcap/grid-pro';
import { css } from '@microsoft/fast-element';
import { agThemeGenesisRapidTokens } from '../../style/tokens';
import { agThemeGenesisRapidCSS } from './ag-theme-genesis-rapid-css';
export const agThemeGenesisRapidTokenMap = {
    [AgGridCSSVars.backgroundColor]: agThemeGenesisRapidTokens.backgroundColor,
    [AgGridCSSVars.foregroundColor]: agThemeGenesisRapidTokens.foregroundColor,
    [AgGridCSSVars.oddRowBackgroundColor]: agThemeGenesisRapidTokens.backgroundColor,
    [AgGridCSSVars.headerBackgroundColor]: agThemeGenesisRapidTokens.backgroundColor,
    [AgGridCSSVars.headerForegroundColor]: agThemeGenesisRapidTokens.headerForegroundColor,
    [AgGridCSSVars.selectedRowBackgroundColor]: agThemeGenesisRapidTokens.rowHoverColor,
    [AgGridCSSVars.rowHoverColor]: agThemeGenesisRapidTokens.rowHoverColor,
    [AgGridCSSVars.borderColor]: agThemeGenesisRapidTokens.borderColor,
    [AgGridCSSVars.rowBorderColor]: agThemeGenesisRapidTokens.rowHoverColor,
    [AgGridCSSVars.modalOverlayBackgroundColor]: agThemeGenesisRapidTokens.backgroundColor,
    [AgGridCSSVars.inputFocusBoxShadow]: agThemeGenesisRapidTokens.headerForegroundColor,
    [AgGridCSSVars.inputFocusBorderColor]: agThemeGenesisRapidTokens.headerForegroundColor,
    [AgGridCSSVars.headerColumnResizeHandleColor]: agThemeGenesisRapidTokens.headerForegroundColor,
};
export const themeGenesisRapid = 'ag-theme-genesis-rapid';
export const agThemeGenesisRapid = css `
  ${agThemeGenesisRapidCSS}
  ${agThemeTokenMapCSS(themeGenesisRapid, agThemeGenesisRapidTokenMap)}

  .${themeGenesisRapid} {
    ${mixinRobotoFont()}
  }

  .${themeGenesisRapid} .ag-header {
    border-bottom-color: var(--rapid-ag-header-foreground-color);
    font-weight: bold;
  }

  .${themeGenesisRapid} .ag-root-wrapper {
    border-radius: calc(var(--control-corner-radius) * 1px);
  }
`;
export const themeGenesisRapidDark = 'ag-theme-genesis-rapid-dark';
export const agThemeGenesisRapidDark = css `
  ${agThemeGenesisRapidCSS}
  ${agThemeTokenMapCSS(themeGenesisRapidDark, agThemeGenesisRapidTokenMap)}

  .${themeGenesisRapidDark} {
    ${mixinRobotoFont()}
  }

  .${themeGenesisRapidDark} .ag-header {
    border-bottom-color: var(--rapid-ag-header-foreground-color);
    font-weight: bold;
  }

  .${themeGenesisRapidDark} .ag-cell {
    line-height: var(--ag-line-height, 32px);
  }

  .${themeGenesisRapidDark} .ag-root-wrapper {
    border-radius: calc(var(--control-corner-radius) * 1px);
  }
`;
